module.exports = __webpack_public_path__ + "img/4.68c0f571.png";